// Tab List (FilterCategory)
export const TabList = [
	{
		id: "awaiting_purchase",
		title: "Awaiting Purchase",
	},
	{
		id: "awaiting_procurement",
		title: "Awaiting Procurement",
	},
	{
		id: "procured_assets",
		title: "Procured assets",
	},
	{
		id: "deployed_assets",
		title: "Deployed assets",
	},
	{
		id: "maintained_assets",
		title: "Maintained assets",
	},
	{
		id: "inspected_assets",
		title: "Inspected assets",
	},
	{
		id: "retained_assets",
		title: "Retained assets",
	},
	{
		id: "retrieved_assets",
		title: "Retrieved Assets",
	},
	{
		id: "reassigned_assets",
		title: "Reassigned Assets",
	},
	{
		id: "sold_assets",
		title: "Sold Assets",
	},
	{
		id: "repaired_assets",
		title: "Repaired assets",
	},
];

export const repairStatusOptions = ["bad", "fixed"];

// Table Head Cells - Leasing
export const AwaitingHeaderLease = [
	{ field: "createdAt", title: "DATE/TIME", width: 110 },
	{ field: "trnId", title: "TRANSACTION ID", width: 167 },
	{ field: "productObj.productName", title: "ASSET NAME", width: 80 },
	{ field: "productCategory", title: "CATEGORY", width: 110 },
	{ field: "price", title: "VALUE", width: 80 },
	{ field: "condition", title: "CONDITION", width: 80 },
	{ field: "filter_lease", title: "ACTION", sortable: false, width: 80 },
];

export const PurchasedHeaderLease = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "trnId", title: "TRANSACTION ID", width: 167 },
	{ field: "leaseType", title: "LEASE TYPE", width: 60 },
	// { field: "leasee", title: "LEASEE", width: 60 },
	{ field: "productObj.productName", title: "ASSET NAME", width: 80 },
	{ field: "productCategory", title: "CATEGORY", width: 120 },
	{ field: "price", title: "VALUE", width: 60 },
	{ field: "condition", title: "CONDITION", width: 60 },
	{ field: "leaseStructure", title: "LEASE STRUCTURE", width: 60 },
	{ field: "approvalStatus", title: "APPROVAL LEVEL", width: 60 },
	{ field: "filter_lease", title: "ACTION", sortable: false, width: 60 },
];

export const DeployedHeaderLease = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "trnId", title: "TRANSACTION ID", width: 167 },
	// { field: "leasee", title: "RECIPIENT", width: 60 },
	{ field: "productObj.productName", title: "ASSET NAME", width: 80 },
	{ field: "deliveryType", title: "DELIVERY METHOD", width: 60 },
	{ field: "deliveryInfo.deliveryFee", title: "DELIVERY FEE", width: 120 },
	{ field: "deliveryInfo.deliveryAgent", title: "AGENT", width: 60 },
	{ field: "deliveryInfo.deliveryDate", title: "EST. ARRIVAL", width: 120 },
	{ field: "approvalStatus", title: "STATUS", width: 60 },
	{ field: "filter_lease", title: "ACTION", sortable: false, width: 70 },
];

export const MaintainedHeaderLease = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "trnId", title: "TRANSACTION ID", width: 167 },
	{ field: "leasee", title: "LEASEE", width: 60 },
	{ field: "product.productName", title: "ASSET NAME", width: 80 },
	{ field: "productCategory", title: "CATEGORY", width: 120 },
	{ field: "price", title: "VALUE", width: 60 },
	{ field: "condition", title: "CONDITION", width: 60 },
	{ field: "leaseStructure", title: "LEASE STRUCTURE", width: 60 },
	{ field: "fault", title: "FAULT", width: 60 },
	{ field: "maintenanceStatus", title: "STATUS", width: 60 },
	{ field: "filter_lease", title: "ACTION", sortable: false, width: 60 },
];

export const InspectedHeaderLease = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "trnId", title: "TRANSACTION ID", width: 167 },
	{ field: "leasee", title: "LEASEE", width: 60 },
	{ field: "product.productName", title: "ASSET NAME", width: 80 },
	{ field: "productCategory", title: "CATEGORY", width: 120 },
	{ field: "price", title: "VALUE", width: 60 },
	{ field: "condition", title: "CONDITION", width: 60 },
	{ field: "leaseStructure", title: "LEASE STRUCTURE", width: 60 },
	{ field: "inspectionStatus", title: "STATUS", width: 60 },
	{ field: "filter_lease", title: "ACTION", sortable: false, width: 60 },
];

export const RetainedHeaderLease = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "trnId", title: "TRANSACTION ID", width: 167 },
	{ field: "leasee", title: "LEASEE", width: 60 },
	{ field: "product.productName", title: "ASSET NAME", width: 80 },
	{ field: "productCategory", title: "CATEGORY", width: 120 },
	{ field: "price", title: "VALUE", width: 60 },
	{ field: "condition", title: "CONDITION", width: 60 },
	{ field: "leaseStructure", title: "LEASE STRUCTURE", width: 60 },
	{ field: "retainmentStatus", title: "STATUS", width: 60 },
	{ field: "filter_lease", title: "ACTION", sortable: false, width: 60 },
];

export const RepairedHeaderLease = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "trnId", title: "TRANSACTION ID", width: 167 },
	{ field: "leasee", title: "LEASEE", width: 60 },
	{ field: "product.productName", title: "ASSET NAME", width: 80 },
	{ field: "productCategory", title: "CATEGORY", width: 120 },
	{ field: "price", title: "VALUE", width: 60 },
	{ field: "condition", title: "CONDITION", width: 60 },
	{ field: "leaseStructure", title: "LEASE STRUCTURE", width: 60 },
	{ field: "fault", title: "FAULT", width: 60 },
	{ field: "repairStatus", title: "STATUS", width: 60 },
	{ field: "filter_lease", title: "ACTION", sortable: false, width: 60 },
];

// Table Head Cells - Apprenticeship Finance
export const AwaitingHeaderAF = [
	{ field: "createdAt", title: "DATE/TIME", width: 110 },
	{ field: "trnId", title: "TRANSACTION ID", width: 167 },
	{ field: "type", title: "AF TYPE", width: 60 },
	// { field: "apprentice", title: "APPRENTICE", width: 80 },
	{ field: "tenure", title: "TENURE", width: 80 },
	{ field: "amountToRaise", title: "AMOUNT TO RAISE", width: 110 },
	{ field: "businessType", title: "BUSINESS TYPE", width: 60 },
	{ field: "filter_AFinance", title: "ACTION", sortable: false, width: 60 },
];

export const PurchasedHeaderAF = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "trnId", title: "TRANSACTION ID", width: 167 },
	// { field: "BusinessInterest", title: "BUSINESS INTEREST", width: 60 },
	{ field: "type", title: "AF TYPE", width: 60 },
	// { field: "apprentice", title: "APPRENTICE", width: 80 },
	{ field: "amountToRaise", title: "AMOUNT TO RAISE", width: 120 },
	{ field: "interestRate", title: "INTEREST", width: 60 },
	{ field: "businessType", title: "BUSINESS TYPE", width: 60 },
	{ field: "request", title: "REQUEST", width: 60 },
	{ field: "approvalStatus", title: "APPROVAL", width: 60 },
	{ field: "filter_AFinance", title: "ACTION", sortable: false, width: 60 },
];

export const DeployedHeaderAF = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "trnId", title: "TRANSACTION ID", width: 167 },
	// { field: "apprentice", title: "RECIPIENT", width: 60 },
	{ field: "businessType", title: "BUSINESS TYPE", width: 60 },
	{ field: "deliveryType", title: "DELIVERY METHOD", width: 60 },
	{ field: "deliveryInfo.deliveryFee", title: "DELIVERY FEE", width: 120 },
	{ field: "deliveryInfo.deliveryAgent", title: "AGENT", width: 60 },
	{ field: "deliveryInfo.deliveryDate", title: "EST. ARRIVAL", width: 60 },
	{ field: "approvalStatus", title: "STATUS", width: 60 },
	{ field: "filter_AFinance", title: "ACTION", sortable: false, width: 70 },
];

export const MaintainedHeaderAF = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "trnId", title: "TRANSACTION ID", width: 167 },
	{ field: "apprentice", title: "APPRENTICE", width: 80 },
	{ field: "BusinessInterest", title: "BUSINESS INTEREST", width: 60 },
	{ field: "amountToRaise", title: "AMOUNT TO RAISE", width: 120 },
	{ field: "businessType", title: "BUSINESS TYPE", width: 60 },
	{ field: "maintenanceStatus", title: "STATUS", width: 60 },
	{ field: "filter_AFinance", title: "ACTION", sortable: false, width: 60 },
];

export const InspectedHeaderAF = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "trnId", title: "TRANSACTION ID", width: 167 },
	{ field: "apprentice", title: "APPRENTICE", width: 80 },
	{ field: "BusinessInterest", title: "BUSINESS INTEREST", width: 60 },
	{ field: "amountToRaise", title: "AMOUNT TO RAISE", width: 120 },
	{ field: "businessType", title: "BUSINESS TYPE", width: 60 },
	{ field: "inspectionStatus", title: "STATUS", width: 60 },
	{ field: "filter_AFinance", title: "ACTION", sortable: false, width: 60 },
];

export const RetainedHeaderAF = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "trnId", title: "TRANSACTION ID", width: 167 },
	{ field: "apprentice", title: "APPRENTICE", width: 80 },
	{ field: "BusinessInterest", title: "BUSINESS INTEREST", width: 60 },
	{ field: "amountToRaise", title: "AMOUNT TO RAISE", width: 120 },
	{ field: "businessType", title: "BUSINESS TYPE", width: 60 },
	{ field: "retainmentStatus", title: "STATUS", width: 60 },
	{ field: "filter_AFinance", title: "ACTION", sortable: false, width: 60 },
];

export const RepairedHeaderAF = [
	{ field: "createdAt", title: "DATE/TIME", width: 150 },
	{ field: "trnId", title: "TRANSACTION ID", width: 167 },
	{ field: "apprentice", title: "APPRENTICE", width: 80 },
	{ field: "BusinessInterest", title: "BUSINESS INTEREST", width: 60 },
	{ field: "amountToRaise", title: "AMOUNT TO RAISE", width: 120 },
	{ field: "businessType", title: "BUSINESS TYPE", width: 60 },
	{ field: "fault", title: "FAULT", width: 60 },
	{ field: "repairStatus", title: "STATUS", width: 60 },
	{ field: "filter_AFinance", title: "ACTION", sortable: false, width: 60 },
];
